import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

export interface TeamCreditsActionProps {
  credits: number;
  freeCredits: number;
  freeCreditsExpiryDate: string | null;
  legacyCredits: number;
  legacyCreditsExpiryDate: string | null;
  purchasedCredits: number;
  renewalCredits: number | null;
  renewalDate: string | null;
}

interface TeamCreditsProps {
  credits: number | null;
  freeCredits: number;
  freeCreditsExpiryDate: string | null;
  legacyCredits: number;
  legacyCreditsExpiryDate: string | null;
  purchasedCredits: number;
  renewalCredits: number | null;
  renewalDate: string | null;
}

const initialState: TeamCreditsProps = {
  credits: null,
  freeCredits: 0,
  freeCreditsExpiryDate: null,
  legacyCredits: 0,
  legacyCreditsExpiryDate: null,
  purchasedCredits: 0,
  renewalCredits: null,
  renewalDate: null,
};

export const teamCreditsSlice = createSlice({
  name: 'teamCreditsCredits',
  initialState,
  reducers: {
    updateTeamCredits: (state, action: PayloadAction<TeamCreditsActionProps>) => {
      state.credits = action.payload.credits;
      state.freeCredits = action.payload.freeCredits;
      state.freeCreditsExpiryDate = action.payload.freeCreditsExpiryDate;
      state.legacyCredits = action.payload.legacyCredits;
      state.legacyCreditsExpiryDate = action.payload.legacyCreditsExpiryDate;
      state.purchasedCredits = action.payload.purchasedCredits;
      state.renewalCredits = action.payload.renewalCredits;
      state.renewalDate = action.payload.renewalDate;
    },

    resetTeamCredits: (state) => {
      state.credits = null;
      state.freeCredits = 0;
      state.freeCreditsExpiryDate = null;
      state.legacyCredits = 0;
      state.legacyCreditsExpiryDate = null;
      state.purchasedCredits = 0;
      state.renewalCredits = null;
      state.renewalDate = null;
    },
  },
});

export const {updateTeamCredits, resetTeamCredits} = teamCreditsSlice.actions;
export const teamCreditsReducer = teamCreditsSlice.reducer;
